import React from 'react';
import {Button} from 'wix-ui-tpa/Button';
import {classes} from './CheckoutButton.st.css';
import {ReactComponent as Lock} from '../../../../../../assets/images/Lock.svg';
import classnames from 'classnames';
import {useControllerProps} from '../../../ControllerContext';
import settingsParams from '../../../../settingsParams';
import {useSettings} from 'yoshi-flow-editor-runtime/tpa-settings/react';

export enum CheckoutButtonDataHook {
  button = 'CheckoutButtonDataHook.button',
}

export interface CheckoutButtonProps {
  disabled?: boolean;
}

export function CheckoutButton({disabled}: CheckoutButtonProps) {
  const {get: getSettings} = useSettings();
  const accessibilityEnabled = useControllerProps().host.accessibilityEnabled;
  const {navigateToCheckout} = useControllerProps().navigationStore;
  const {shouldShowNewSslLogo} = useControllerProps().cartStore;

  return (
    <Button
      className={classnames(classes.checkoutButton)}
      data-hook={CheckoutButtonDataHook.button}
      disabled={disabled}
      onClick={() => navigateToCheckout({accessibilityEnabled})}
      upgrade>
      {!shouldShowNewSslLogo ? <Lock key={''} /> : null}
      <span className={classes.checkoutButtonLabel}>{getSettings(settingsParams.CART_BUTTON_TEXT)}</span>
    </Button>
  );
}
